/**
 * Loads parent section images for cross fading.
 *
 * @param {JQuery} $slider
 * @returns void
 */
const loadSectionImages = ($slider) => {
	const $sliderParentBlock = $slider.parents('.block-slider-basic'); // slider parent section
	const $parentSection = $slider.parents('.block-section'); // top most parent section
	const images = $sliderParentBlock.data('slide-images');
	const breakpoint = '768px';
	let $targetDiv;

	if (typeof images === 'undefined' || images.length === 0) return;

	$parentSection.append('<div class="block-section__background"></div>')
		.removeClass('has-default-margin')
		.removeClass('has-zero-padding')
		.addClass('has-zero-margin');

	images.forEach((img, i) => {
		$parentSection.find('.block-section__background').append(`<picture>
			<source srcset="${img['desktop']}" media="(min-width:${breakpoint})" />
			<img src="${img['mobile']}" style="display:none;" alt="" />
		</picture>`);
	});
}

/**
 * Updates the active section background.
 *
 * @param {JQuery} $slider
 * @param {int} imageIndex
 */
const updateSectionBackground = ($slider, imageIndex) => {
	const $sliderParentBlock = $slider.parents('.block-slider-basic'); // slider parent section
	const $parentSection = $slider.parents('.block-section'); // top most parent section
	const $target = $parentSection.find('.block-section__background');
	const delay = 400;

	$target.find('img').fadeOut(delay);
	$target.find('img').eq(imageIndex).fadeIn(delay);
};

/**
 * Initializes all sliders.
 * All sliders have option to sync images with parent div. This will cause
 * the slider to update the div on the background.
 */
$('.basic-slider').each((i, el) => {
	const $el = $(el);
	const $sliderEl = $el;
	const numSlides = $sliderEl.find('.slide').length;
	const $controls = $sliderEl.next('.js-slider-controls');
	const { nextArrow, prevArrow } = Globals.sliders;

	let config = {
		dots: numSlides > 1,
		nextArrow,
		prevArrow,
		appendArrows: $controls,
		appendDots: $controls,
	};

	const $slider = $sliderEl.on('init', (e, slick) => {
		loadSectionImages($sliderEl);
		updateSectionBackground($sliderEl, 0);
	}).on('afterChange', (e, slick, currentSlide) => {
		updateSectionBackground($sliderEl, currentSlide);
	}).slick(config);

});

